import { render, staticRenderFns } from "./prepareLesson.vue?vue&type=template&id=33b9b5b0&scoped=true"
import script from "./prepareLesson.vue?vue&type=script&lang=js"
export * from "./prepareLesson.vue?vue&type=script&lang=js"
import style0 from "./prepareLesson.vue?vue&type=style&index=0&id=33b9b5b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b9b5b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33b9b5b0')) {
      api.createRecord('33b9b5b0', component.options)
    } else {
      api.reload('33b9b5b0', component.options)
    }
    module.hot.accept("./prepareLesson.vue?vue&type=template&id=33b9b5b0&scoped=true", function () {
      api.rerender('33b9b5b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsteacher/teacher/prepareLesson.vue"
export default component.exports